module.exports = __webpack_public_path__ + "img/result1.94d4284c.png";